import type { TOC } from '@ember/component/template-only';

import BoardsIndexGridComponent from 'webapp/components/boards/index/grid';
import BoardsIndexTableComponent from 'webapp/components/boards/index/table';
import EmptyScreensBoardsComponent from 'webapp/components/empty-screens/boards';
import TemplatesPublicRecommendedBoardsComponent from 'webapp/components/templates/public/recommended-boards';
import type BoardsIndexController from 'webapp/controllers/boards/index';

interface Args {
	controller: BoardsIndexController;
}

const BoardsIndexRouteTemplate: TOC<Args> = <template>
	<div class="container__recommended">
		{{#if @controller.hasBoards}}
			<div id="home-boards" class="view-{{@controller.viewId}}">
				{{#if @controller.isTableView}}
					<BoardsIndexTableComponent
						@model={{@controller.boards}}
						@transferedBoardPublicTemplateNotifications={{@controller.transferedBoardPublicTemplateNotifications}}
						@transferedBoardAccountTemplateNotifications={{@controller.transferedBoardAccountTemplateNotifications}}
						@hasBoards={{@controller.hasBoards}}
						@onBoardCreateChoice={{@controller.newBoardOptions}}
						@onOpenView={{@controller.openView}}
						@onBoardCreate={{@controller.createBoard}}
						@onCopy={{@controller.copyBoard}}
						@onBoardCreateWizard={{@controller.createBoardWizard}}
						@updateIsRecentlyDeletedFilterActive={{@controller.updateRecentlyDeletedFilter}}
					/>
				{{else}}
					<BoardsIndexGridComponent
						@model={{@controller.boards}}
						@transferedBoardPublicTemplateNotifications={{@controller.transferedBoardPublicTemplateNotifications}}
						@transferedBoardAccountTemplateNotifications={{@controller.transferedBoardAccountTemplateNotifications}}
						@hasBoards={{@controller.hasBoards}}
						@onBoardCreateChoice={{@controller.newBoardOptions}}
						@onOpenView={{@controller.openView}}
						@onBoardCreate={{@controller.createBoard}}
						@onCopy={{@controller.copyBoard}}
						@onBoardCreateWizard={{@controller.createBoardWizard}}
						@updateIsRecentlyDeletedFilterActive={{@controller.updateRecentlyDeletedFilter}}
					/>
				{{/if}}
			</div>
		{{else}}
			<EmptyScreensBoardsComponent />
		{{/if}}

		<TemplatesPublicRecommendedBoardsComponent
			@isHidden={{@controller.hideRecommendedTemplates}}
		/>
	</div>
</template>;

export default BoardsIndexRouteTemplate;
